import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import GenericModal from '../GenericModal';
import { Exercise } from '../../../../core/model';
import ExerciseForm from '../../../../pages/Classes/ExerciseForm';
import { formatDataToModel } from '../../../../utils';
import Detail from './Detail';

const ModalStyled = styled(GenericModal)`
  overflow: hidden;
  padding: 40px 10px 0;
`
const ExerciseFormStyled = styled(ExerciseForm)`

`
const Scrollable = styled.div`
  // min-height: 500px;
  height: 80vh;
  overflow-y: auto;
`

class ExerciseViewDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  
  render() {
    const {
      children,
      // onClose,
      onEdit,
      onSubmit,
      edit,
      data,
      onBackdropClick,
      allowEdit,
      ...other
    } = this.props;

    // tags could be an array of strings or an array of objects
    // if the latter, convert to an array of strings
    const tags = data.tags.map(item => {
      return typeof item === "string" ? item : item.value;
    });

    const modData = Object.assign({}, data, { tags: tags });
    const exerciseData = formatDataToModel(modData, Exercise);

    return (
      <ModalStyled {...other}>
        <Scrollable>
          {
            edit ? (
              <ExerciseFormStyled
                data={exerciseData}
                updateExercise={onSubmit}
                close={() => onEdit(false)}
              />
            ) : (
              <Detail
                data={exerciseData}
                onEdit={onEdit}
                allowEdit={allowEdit}
              />
            )
          }
        </Scrollable>
      </ModalStyled>
    );
  }
}

ExerciseViewDetail.propTypes = {
  onEdit: PropTypes.func,
  onClose: PropTypes.func,
  data: PropTypes.object,
  edit: PropTypes.bool,
  allowEdit: PropTypes.bool,
};

ExerciseViewDetail.defaultProps = {
  edit: false,
  allowEdit: true,
}

export default ExerciseViewDetail;
